import React, { useRef, useEffect, useState } from 'react';

const CameraModal = ({ show, onCapture, onClose }) => {
  const videoRef = useRef(null);
  const [stream, setStream] = useState(null);

  useEffect(() => {
    if (show) {
      // Request camera access
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
        .then(stream => {
          setStream(stream);
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
          }
        })
        .catch(err => {
          console.error("Error accessing camera:", err);
          onClose(); // Close modal if camera access is denied
        });
    } else {
      // Stop the stream when the modal is closed
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    }

    // Cleanup function to stop stream on component unmount
    return () => {
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
  }, [show]);

  const handleCapture = () => {
    const canvas = document.createElement('canvas');
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    canvas.getContext('2d').drawImage(videoRef.current, 0, 0);
    canvas.toBlob(blob => {
      onCapture(blob);
    }, 'image/jpeg');
  };

  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white p-4 rounded-lg shadow-xl w-full max-w-lg">
        <video ref={videoRef} autoPlay playsInline className="w-full rounded-md"></video>
        <div className="flex justify-center mt-4">
          <button onClick={handleCapture} className="bg-blue-600 text-white px-6 py-2 rounded-full font-semibold text-lg">
            Capture
          </button>
          <button onClick={onClose} className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full w-8 h-8">
            &times;
          </button>
        </div>
      </div>
    </div>
  );
};

export default CameraModal;
